import { IconButton, Text } from "@/elements"
import { FragmentType, useFragment } from "@/gql"
import { DraftJobPostingFragmentDoc, JobPostingLocationType } from "@/gql/graphql"
import { TrashIcon } from "@heroicons/react/24/outline"
import { format, formatDistanceToNow, isWithinInterval, subDays } from "date-fns"
import { useState } from "react"
import { DeleteDraftJobPostingModal } from "./DeleteDraftJobPostingModal"
import adjustDateForTimezone from "@/utils/dates"

const TableRowCell = ({ text }: { text: string | null | undefined }) => {
  return (
    <td className={`whitespace-break-spaces px-4 text-left`}>
      <div className="flex items-center">
        <Text variant="label" className="text-fg-2">
          {text}
        </Text>
      </div>
    </td>
  )
}

interface Props {
  onClick: (id: string) => void
  data: FragmentType<typeof DraftJobPostingFragmentDoc> | null | undefined
}

const TableRow: React.FC<Props> = props => {
  const item = useFragment(DraftJobPostingFragmentDoc, props.data)
  const now = adjustDateForTimezone(new Date().toISOString())!

  const [deleteJobPostingModalOpen, setDeleteJobPostingModalOpen] = useState(false)
  if (!item) return null

  let jobDate = "N/A"
  if (item.startDate) {
    jobDate = `${format(adjustDateForTimezone(item.startDate)!, "MMM d, yyyy")} ${item.endDate ? ` - ${format(adjustDateForTimezone(item.startDate)!, "MMM d, yyyy")}` : ""}`
  }
  if (item.datesAreFlexible) {
    jobDate = `${jobDate} (Flexible dates)`
  }
  if (!item.startDate && item.datesAreFlexible) {
    jobDate = "Flexible dates"
  }

  return (
    <>
      <tr
        key={item.id}
        onClick={() => props.onClick(item.id)}
        className="h-[54px] cursor-pointer border-b border-bg-3 hover:bg-bg-2 hover:bg-opacity-40">
        <TableRowCell text={`${item.position?.name || ""}`} />

        <TableRowCell text={item.locationType === JobPostingLocationType.Telecommute ? "Remote" : item.locationName} />
        <TableRowCell text={jobDate} />

        <TableRowCell
          text={
            isWithinInterval(item.createdAt, { start: subDays(now, 7), end: now })
              ? formatDistanceToNow(item.createdAt, { addSuffix: true })
              : format(item.createdAt, "MMM d, yyyy")
          }
        />
        <td className="h-[53px] whitespace-nowrap px-6 text-left">
          <div className="flex items-center justify-center gap-x-4">
            {/* <IconButton Icon={() => <PencilSquareIcon width={20} height={20} color={getHex("fg-2")} />} size="small" /> */}
            <IconButton
              variant="white"
              Icon={TrashIcon}
              size="small"
              onClick={e => {
                e.preventDefault()
                e.stopPropagation()
                setDeleteJobPostingModalOpen(true)
              }}
            />
          </div>
        </td>
      </tr>
      <DeleteDraftJobPostingModal
        jobId={item.id}
        open={deleteJobPostingModalOpen}
        onClose={() => setDeleteJobPostingModalOpen(false)}
        typename={item.__typename!}
      />
    </>
  )
}

export default TableRow
